import { graphql } from "@/graphql";

export const currentUserAuthQuery = graphql(`
  query CurrentUserAuthQuery {
    currentUser {
      id
      isTermsAccepted
    }
  }
`);

export const termsAndConditionsQuery = graphql(`
  query TermsAndConditionsQuery($tacType: String!) {
    termsAndConditions(tacType: $tacType) {
      id
      title
      description
    }
  }
`);
